import { render, staticRenderFns } from "./ReleaseTable.vue?vue&type=template&id=c3a007d2&scoped=true"
import script from "./ReleaseTable.vue?vue&type=script&lang=js"
export * from "./ReleaseTable.vue?vue&type=script&lang=js"
import style0 from "./ReleaseTable.vue?vue&type=style&index=0&id=c3a007d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a007d2",
  null
  
)

export default component.exports